export default __webpack_public_path__ + "static/media/motion-bg.9c1ab6c1.png";